export default __webpack_public_path__ + "static/media/mobileimage1.679d2b96.png";